import z from 'zod';
export const SkillTypeParamSchema = z.object({
    type: z.enum(['other', 'digital'])
});
//# sourceMappingURL=skillTypeParamSchema.js.map